import { Component, input } from '@angular/core';

@Component({
  selector: 'shared-core-tooltip',
  standalone: true,
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  readonly tooltip = input('');
  readonly dataTestId = input('');
}
